import * as React from "react"
import type { SVGProps } from "react"
const SvgRepeat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12.05 20.14a7.8 7.8 0 0 1-5.7-2.32A7.7 7.7 0 0 1 4 12.14v-.17l-.9.9a1 1 0 0 1-.7.27 1 1 0 0 1-.7-.27 1 1 0 0 1-.27-.7q0-.43.27-.7l2.6-2.6q.3-.3.7-.3t.7.3l2.6 2.6a1 1 0 0 1 .28.7 1 1 0 0 1-.28.7 1 1 0 0 1-.7.27 1 1 0 0 1-.7-.27l-.9-.9v.17q0 2.5 1.76 4.25a5.9 5.9 0 0 0 5.84 1.53q.42-.13.8.02c.38.15.44.28.58.53a1 1 0 0 1 .03.78 1 1 0 0 1-.58.52q-.58.2-1.18.28-.6.1-1.2.1m-.1-14a6 6 0 0 0-.79.05 4 4 0 0 0-.76.18 1.2 1.2 0 0 1-.81-.03A1 1 0 0 1 9 5.82a1 1 0 0 1-.04-.77 1 1 0 0 1 .56-.5 8 8 0 0 1 2.43-.4 7.8 7.8 0 0 1 5.7 2.32A7.7 7.7 0 0 1 20 12.14v.18l.9-.9a1 1 0 0 1 .7-.28q.43 0 .7.28a1 1 0 0 1 .27.7 1 1 0 0 1-.27.7l-2.6 2.6q-.3.3-.7.3a1 1 0 0 1-.7-.3l-2.6-2.6a1 1 0 0 1-.28-.7q0-.43.28-.7a1 1 0 0 1 .7-.28q.43 0 .7.28l.9.9v-.18q0-2.5-1.76-4.25a6 6 0 0 0-4.29-1.75" />
  </svg>
)
export default SvgRepeat
